var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoPersonPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.41594 0.5 0.5 3.41594 0.5 7C0.5 10.5841 3.41594 13.5 7 13.5C10.5841 13.5 13.5 10.5841 13.5 7C13.5 3.41594 10.5841 0.5 7 0.5ZM5.43062 4.15063C5.82656 3.73094 6.38375 3.5 7 3.5C7.61625 3.5 8.16844 3.7325 8.56594 4.15438C8.96875 4.58188 9.16469 5.15625 9.11844 5.77375C9.02594 7 8.07594 8 7 8C5.92406 8 4.97219 7 4.88156 5.77344C4.83563 5.15094 5.03125 4.57469 5.43062 4.15063ZM7 12.5C6.26577 12.5005 5.53893 12.3535 4.86256 12.0678C4.18619 11.7821 3.57407 11.3635 3.0625 10.8369C3.35548 10.419 3.72879 10.0638 4.16062 9.79187C4.95719 9.28125 5.96531 9 7 9C8.03469 9 9.04281 9.28125 9.83844 9.79187C10.2706 10.0637 10.6442 10.419 10.9375 10.8369C10.426 11.3636 9.81387 11.7823 9.13749 12.0679C8.46111 12.3536 7.73424 12.5006 7 12.5Z",
    fill: "#E4ECF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoPersonPhoto);
export default __webpack_public_path__ + "static/media/ic_no_person_photo.f469e2b5da978fb55d1f8474086e809e.svg";
export { ForwardRef as ReactComponent };